import React from 'react';
import { IConfig } from '../../../Interfaces/IConfig';
import { ILegalTransactionFullObject } from '../../../Interfaces/ILegalTransaction';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { InvoiceDesktopRow } from './InvoiceDesktopRow';

interface IProps {
  configObject: IConfig;
  legalTransactionObject: ILegalTransactionFullObject;
  handleClose?: () => void;
}

export const InvoiceDesktop: React.FC<IProps> = ({
  configObject,
  legalTransactionObject,
  handleClose,
}) => {
  return (
    <>
      <Typography variant='h5'>Digitale Rechnungen</Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: 80 }}>Nr.</TableCell>
            <TableCell sx={{ width: 80 }}>QR</TableCell>
            <TableCell sx={{ width: 150 }}>Status</TableCell>
            <TableCell sx={{ width: 150 }}>Summe</TableCell>
            <TableCell>Dateiname</TableCell>

            <TableCell sx={{ width: 100 }}>Aktionen</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {legalTransactionObject.InvoiceObjectArray.length === 0 && (
            <TableRow>
              <TableCell colSpan={6}>
                <i>Keine Rechnungen vorliegend.</i>
              </TableCell>
            </TableRow>
          )}
          {legalTransactionObject.InvoiceObjectArray.map(invoice => (
            <InvoiceDesktopRow
              key={`invoice-object-${invoice.idInvoice}`}
              configObject={configObject}
              invoice={invoice}
              legalTransactionObject={legalTransactionObject}
              handleClose={handleClose}
            />
          ))}
        </TableBody>
      </Table>
    </>
  );
};
